import React from 'react';
import {
    Card, CardContent, Typography, CardMedia, Box, Button,
    List, ListItem, ListItemIcon, Accordion, AccordionSummary,
    AccordionDetails
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const locations = [
    {
        name: 'Winston-Salem, NC',
        address: '664 E Monmouth St Winston-Salem, NC – 27107',
        phone: '(336) 624-5244',
        phoneNumber: '+13366245244',
        operatingHours: [
            { day: 'Monday', time: '5:00 AM - 1:00 AM' },
            { day: 'Tuesday', time: '5:00 AM - 1:00 AM' },
            { day: 'Wednesday', time: '5:00 AM - 1:00 AM' },
            { day: 'Thursday', time: '5:00 AM - 1:00 AM' },
            { day: 'Friday', time: '5:00 AM - 1:00 AM' },
            { day: 'Saturday', time: '5:00 AM - 1:00 AM' },
            { day: 'Sunday', time: '5:00 AM - 1:00 AM' },
        ],
        servicesHours: [
            { day: 'Monday', time: '8:00 AM - 8:00 PM' },
            { day: 'Tuesday', time: '8:00 AM - 8:00 PM' },
            { day: 'Wednesday', time: '8:00 AM - 8:00 PM' },
            { day: 'Thursday', time: '8:00 AM - 8:00 PM' },
            { day: 'Friday', time: '8:00 AM - 9:00 PM' },
            { day: 'Saturday', time: '7:00 AM - 9:00 PM' },
            { day: 'Sunday', time: '7:00 AM - 9:00 PM' },
        ],
        services: [
            'Safe, Modern, Clean Environment',
            'Brand New, Large Capacity & High Efficiency Machines with Touchscreens',
            'Wash, Dry, and Fold Service',
            'Pickup & Delivery',
            'Commercial Laundry',
            'No need for coins. You can pay with Laundry Card or with your phone using the Dexter Pay App.'
        ],
        image: '/laundromatPicture.JPG',
        directionsLink: 'https://maps.app.goo.gl/NU93FonLJW9dEGgG8'
    },
];

const LocationsList: React.FC = () => {
    return (
        <Box sx={{ backgroundColor: 'background.default', padding: 5 }}>
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 4,
                    justifyContent: 'center',
                }}
            >
                {locations.map((location, index) => (
                    <Card
                        key={index}
                        sx={{
                            width: 320,
                            minHeight: 520,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            boxShadow: 3,
                            borderRadius: 2,
                            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                        }}
                    >
                        <CardMedia
                            component="div"
                            sx={{
                                height: 120,
                                backgroundImage: `url(${location.image})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center 20%',
                                position: 'relative',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '100%',
                            }}
                        >
                            <Box
                                sx={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    backgroundColor: 'rgba(255, 255, 255, 0.5)',
                                    zIndex: 1,
                                }}
                            />
                            <Typography
                                variant="h6"
                                sx={{
                                    fontWeight: 'bold',
                                    textTransform: 'uppercase',
                                    position: 'relative',
                                    zIndex: 2,
                                    textAlign: 'center',
                                }}
                            >
                                {location.name}
                            </Typography>
                        </CardMedia>

                        <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <Box sx={{ width: '100%' }}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                                    Contact Details
                                </Typography>
                                <a href={location.directionsLink} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                        <LocationOnIcon color="success" sx={{ mr: 1 }} />
                                        <Typography variant="body2">{location.address}</Typography>
                                    </Box>
                                </a>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <PhoneIcon color="success" sx={{ mr: 1 }} />
                                    <a href={`tel:${location.phoneNumber}`} style={{ textDecoration: 'none', color: 'green', fontWeight: 'bold' }}>
                                        {location.phone}
                                    </a>
                                </Box>

                                {/* Self-Serve Operation Hours Dropdown */}
                                <Accordion sx={{ }}>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                        <AccessTimeIcon color="success" sx={{ mr: 1 }} />
                                        <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                                            Self-Serve Operating Hours
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        {location.operatingHours.map((hour, i) => (
                                            <Box key={i} sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                                                <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                                                    {hour.day}:
                                                </Typography>
                                                <Typography variant="body2">{hour.time}</Typography>
                                            </Box>
                                        ))}
                                    </AccordionDetails>
                                    <AccordionDetails>
                                        <Typography variant="body2" sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                                            Last loads must be in by 11:45 PM
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>

                                {/* Wash, Dry and Fold Dropdown */}
                                <Accordion sx={{ marginTop: 1 }}>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                        <AccessTimeIcon color="success" sx={{ mr: 1 }} />
                                        <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                                            Wash, Dry & Fold Hours
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        {location.servicesHours.map((hour, i) => (
                                            <Box key={i} sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                                                <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                                                    {hour.day}:
                                                </Typography>
                                                <Typography variant="body2">{hour.time}</Typography>
                                            </Box>
                                        ))}
                                    </AccordionDetails>
                                </Accordion>

                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mt: 2, mb: 1 }}>
                                    Services
                                </Typography>
                                <List dense>
                                    {location.services.map((service, i) => (
                                        <ListItem key={i} sx={{ py: 0 }}>
                                            <ListItemIcon>
                                                <CheckCircleIcon color="success" />
                                            </ListItemIcon>
                                            <Typography variant="body2">{service}</Typography>
                                        </ListItem>
                                    ))}
                                </List>
                            </Box>
                        </CardContent>

                        <Box sx={{ p: 2, textAlign: 'center', width: '100%' }}>
                            <Button
                                variant="contained"
                                fullWidth
                                sx={{ color: 'white', fontWeight: 'bold' }}
                                href={location.directionsLink}
                                target="_blank"
                            >
                                Get Directions
                            </Button>
                        </Box>
                    </Card>
                ))}
            </Box>
        </Box>
    );
};

export default LocationsList;
